import { FC } from 'react';
import { Box } from 'enova-frontend-components';
import { FieldError } from 'react-hook-form';

import { OppvarmingBrukRadio } from '../components/oppvarmingBrukRadio';
import { ServiceRadio } from '../components/serviceRadio';
import { Fordelingssystem } from '../components/fordelingssystem';
import { JaNeiVetIkke, OppvarmingBruk, Termostatstyring } from '../../../../../utils/registerEnums';
import { KjelKaminVannbarenVarme, SolfangerMedVannbarenVarme } from '../../../../../../../types/registration/userInput';
import { YearNumberField } from '../../general/components/yearNumberField';

type ElektrokjelFieldValue = number | Termostatstyring | OppvarmingBruk | JaNeiVetIkke | undefined;

interface Props {
  error?: FieldError;
  value?: KjelKaminVannbarenVarme;
  onChange: (value?: KjelKaminVannbarenVarme) => void;
}

export const VannbarenVarme: FC<Props> = ({ error, value, onChange }) => {
  const showFordelingssystem = value?.bruk !== OppvarmingBruk.Tappevann;

  const onVannbarenVarmeChange = (fieldKey: keyof SolfangerMedVannbarenVarme, fieldValue: ElektrokjelFieldValue) => {
    if (!value) {
      return;
    }

    return onChange({ ...value, [fieldKey]: fieldValue });
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <OppvarmingBrukRadio value={value?.bruk} onChange={(newValue) => onVannbarenVarmeChange('bruk', newValue)} />
      {showFordelingssystem && (
        <Fordelingssystem
          // Pass entire object as value, Fordelingssystem manipulates multiple properties
          value={value}
          error={error}
          informationKey="register.tekniskUtstyr.kjel.fordeling.information"
          labelKey="register.tekniskUtstyr.kamin.fordeling.label"
          onChange={(fieldKey, val) => onVannbarenVarmeChange(fieldKey, val)}
        />
      )}
      <YearNumberField
        value={value?.installasjonsAr}
        onChange={(year) => onVannbarenVarmeChange('installasjonsAr', year || undefined)}
        informationKey="register.tekniskUtstyr.vannbarenVarme.installasjonsAr.information"
      />
      <ServiceRadio
        value={value?.serviceGjennomfortSiste2Ar}
        i18nPrefix="register.tekniskUtstyr.kjel.serviceGjennomfortSiste2Ar"
        onChange={(val) => onVannbarenVarmeChange('serviceGjennomfortSiste2Ar', val)}
      />
    </Box>
  );
};
